
import { isPlainObject, mapKeys, mapValues, camelCase } from 'lodash';
import { Picture } from './types/reviews';

// Variables
export const DOVEMED_CORE_URL = window.location.origin;


//@ts-ignore
export const mapKeysDeepLodash = (obj:any, cb:Function, isRecursive?:boolean) => {
  if (!obj && !isRecursive) {
    return {};
  }

  if (!isRecursive) {
    if (typeof obj === "string" || typeof obj === "number" || typeof obj === "boolean") {
      return {};
    }
  }

  if (Array.isArray(obj)) {
    return obj.map(item => mapKeysDeepLodash(item, cb, true));
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  const result = mapKeys(obj, cb);

  return mapValues(result, value =>
    mapKeysDeepLodash(value, cb, true)
  );
};

export const mapToCamelCase = (values: any) => {
  return mapKeysDeepLodash(values, (v:any, k:any) => camelCase(k))
}

export const createFakeSrcSetObject = (picture: string | null | Picture) => {
  if (!picture) {
    return null;
  }
  if (typeof picture === 'string') {
    return {
      low: picture,
      medium: picture,
      high: picture,
      original: picture,
    };
  }
  return picture;
};


export const dateFormat = (initialDate: string) => {
  const date = new Date(initialDate);
  return date.toLocaleDateString('en', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });
};
